import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import { selectFinalUsersListEdited, selectFinalUsersListEditing } from "src/app/store/user-file/user-file.selector";
import * as UserFileActions from 'src/app/store//user-file/user-file.actions';
import { StandardNewValidator, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { FinalUsersList } from "src/app/model/final-users-list";
import { COMMAND_NAME_VALID_REGEXP } from "src/app/conf/commands";
import { selectIsImpersMode, selectUser } from "src/app/store/user/user.selector";
import { User } from "src/app/model/user";

@Component({
	templateUrl: './edit-final-users-dialog.component.html',
})

export class EditFinalUsersDialogComponent implements OnInit, OnDestroy {
	finalUserListForm: FormGroup;

	editing = false;
	editing$: Observable<boolean | undefined>;
	editingSub: Subscription;

	edited = false;
	edited$: Observable<boolean | undefined>;
	editedSub: Subscription;

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	isImpersMode: boolean;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;
	finalUsersList: FinalUsersList;

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,

	) {
		if (config.data !== undefined && config.data.list !== undefined) {
			this.finalUsersList = config.data.list;
		} else {
			this.finalUsersList = new FinalUsersList();
		}

		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();

		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.editingSub?.unsubscribe();
		this.editedSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
	}

	initSelectors(): void {
		this.editing$ = this.store.select(selectFinalUsersListEditing);
		this.edited$ = this.store.select(selectFinalUsersListEdited);
		this.currentUser$ = this.store.select(selectUser);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
	}

	buildForm(): void {
		this.finalUserListForm = new FormGroup({
			'name': new FormControl(this.finalUsersList.Name, [Validators.required, Validators.pattern(COMMAND_NAME_VALID_REGEXP)]),
		});
	}

	subscribeAll(): void {
		this.editingSub = this.editing$?.subscribe(
			(editing) => {
				this.editing = editing;
			}
		);
		this.editedSub = this.edited$?.subscribe(
			(edited) => {
				if (edited) {
					this.closeDialog();
				}
			}
		);
		this.currentUserSub = this.currentUser$?.subscribe(currentUser => {
			this.currentUser = currentUser;
		});
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
	}

	get f(): any {
		return this.finalUserListForm.controls;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.finalUserListForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.finalUserListForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		if (this.isImpersMode) {
			this.store.dispatch(UserFileActions.editFinalUsersList({
				list: this.finalUsersList,
				name: this.finalUserListForm.value.name,
				userId: this.currentUser.Id,
			}));
		} else {
			this.store.dispatch(UserFileActions.editFinalUsersList({
				list: this.finalUsersList,
				name: this.finalUserListForm.value.name
			}));
		}
	}

	closeDialog(): void {
		this.ref.close();
	}

	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: EditFinalUsersDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: EditFinalUsersDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}
}